import { ActivatedRouteSnapshot } from "@angular/router";
import { BaseRouteReuseStrategy } from "@angular/router";

export class ComponentRouteReuseStrategy extends BaseRouteReuseStrategy {

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) {
    return super.shouldReuseRoute(future, curr) || future.component === curr.component;
  }

}
